/* ============================================================================
   OTF — per-window order-by cutoffs for the Order details sheet and the
   next-window line on the home page. 2026-09-04 (CEO): "the time she ordered is 3 to 6pm and the order was
   placed at 5:50pm. We can't work in that time when there's only 10mins left.
   Fix the cutoff time for each time period." Then, on the proposals: "2 and 3
   are cool ... Do the rest." 2026-09-05 (CEO): "The 3 fixed windows should be
   from 12pm-3pm and 3pm-6pm and 6pm-9pm ... the work starts from when we get
   the order and gets done and delivered within 3 hours. That's our promise."

   THE BUG
   -------
   fluid-motion.js decides whether a same-day window can still be chosen with

       timeOpen(t): hour + minutes/60 < t.end        (end = 15, 18, 23.75)

   i.e. a window stays selectable until the minute it ENDS. Order #2249 chose
   "3:00 PM - 6:00 PM" at 5:41 PM. The only real cutoff was the 9pm day rule
   (CUTOFF = 21, after which today leaves the day list - but only when the
   sheet is BUILT; a sheet opened at 8:55 and used at 9:05 still offers today,
   and its day buttons then point one day off, because the click handler
   re-reads a day list that has meanwhile lost today).

   THE RULES NOW (all settings live on the "Fluid bar" section in the editor,
   rendered by sections/fluid-bar.liquid into <div id="fl-slot-cuts">)
   -----------------------------------------------------------------------
   1. The windows are 12-3, 3-6 and 6-9 PM. Each has its own last-order time
      (data-cuts="13:00,16:00,21:00" - CEO, 5 Sep 2026: orders from the 9pm
      cutoff overnight until 1:00 PM belong to 12-3, 3-6 books until 4:00 PM,
      6-9 books until the 9pm cutoff). While Today is selected every window
      shows "Order by <time>"; one past its time is greyed, "Closed for today",
      and cannot be tapped. After 9pm every window counts as closed whatever
      the settings say. If every window has closed, Today is greyed and the
      customer picks another day.
      fluid-motion.js still labels and VALUES its third window "6:00 PM -
      11:45 PM": the label is overridden in fluid-bar.liquid (data-t-ordtimes)
      and the value is rewritten to "6:00 PM - 9:00 PM" at Continue, below.
   2. The 9pm line on the home page gets one more sentence: "Order by <time>
      for <window> delivery." for the next window still open. Empty after 9pm.

   REMOVED 8 Sep 2026 — "EARLIEST POSSIBLE". The CEO: "I created the earliest
   possible tool but i guess it's confusing and i appreciate removing it." It
   offered delivery three hours from the order as a fourth choice above the
   windows. It is gone from this file and its settings are gone from
   sections/fluid-bar.liquid; the three fixed windows are the only same-day
   choice again. If it is ever wanted back, the working version is in git at
   assets/otf-slot-cutoff.js as of commit 22df43d - and note the bug that
   version fixed: the promise MUST be clamped to the delivery day, or a
   customer browsing at 2:15 AM is offered 5:15 AM.

   WHY THIS IS A SEPARATE FILE AND NOT AN EDIT TO fluid-motion.js
   -------------------------------------------------------------
   Same reason as fluid-rv-sheet.js, fluid-sub.js and otf-sheet-locale.js
   (their headers record it): the theme copy of fluid-motion.js is 170 KB of
   minified code that cannot be checksum-verified against what the CDN serves,
   so it is never hand-edited. This file attaches from the OUTSIDE:

   - it watches the document for the sheet's window buttons (.fluid-otime) and
     re-applies the rule every time fluid-motion paints them (open, day tap),
     every 30 s while the sheet is open, and when the tab comes back to the
     foreground - so a window closes on screen at the right minute even if the
     sheet was opened before it;
   - it only ever ADDS disabled. fluid-motion's own end-of-window rule still
     runs underneath; this one is stricter, never looser;
   - it guards "Continue to payment" in the capture phase: fluid-motion keeps
     the chosen window in a closure this file cannot reach, so if the chosen
     window closed while the sheet was open, the click is stopped here and the
     sheet's own time error line says why. Tapping any open window clears it;
   - the attribute rewrite wraps window.fetch for /cart/update.js only, the way
     otf-sheet-locale.js and otf-address-skip.js already do; everything else
     passes through untouched. It exists to turn fluid-motion's stale
     "6:00 PM - 11:45 PM" into "6:00 PM - 9:00 PM" on the order;
   - the 9pm straddle: when a sheet built before 9pm is still open after it,
     a tap on any day REBUILDS the sheet (back, then open again) so the day
     list is fresh and the dates are right; what the customer had typed (card,
     name, phone, note) is carried across. The gift switches are not - they
     are only restored from the cart after a Continue - so that one case asks
     the customer to flip them again. Rare, and correct beats convenient.

   Clock: the same Kuwait-shifted device clock fluid-motion uses (kNow). A
   device with a wrong clock can still lie to both; the authoritative fix is a
   cart validation Function on otf-payment-guard, which needs the Shopify CLI
   on the Mac - agreed with the CEO for a laptop session, not built here.

   Strings come from the section settings (EN and Kuwaiti Arabic fields, the
   voice the CEO set for the whole site on 31 Aug 2026), never from this file;
   the order attribute is English on purpose, like the three window values
   fluid-motion writes. If fluid-motion.js is ever rebuilt from source, fold
   all of this into TIMES/timeOpen()/dayList()/build() and delete it.
   ========================================================================= */
(function () {
  'use strict';
  var cfg = document.getElementById('fl-slot-cuts');
  if (!cfg || !window.MutationObserver) { return; }

  var AR = (document.documentElement.lang || '').indexOf('ar') === 0;
  var DAY_CUT = 21;                       /* fluid-motion's CUTOFF: same-day ordering ends at 21:00 */
  var WIN_EN = ['12:00 PM - 3:00 PM', '3:00 PM - 6:00 PM', '6:00 PM - 9:00 PM'];
  var OLD_THIRD = '6:00 PM - 11:45 PM';   /* what fluid-motion still writes for the third window */

  function attr(n, d) { var v = cfg.getAttribute(n); return (v === null || v === '') ? d : v; }
  /* "13:00,16:00,21:00" -> [13, 16, 21]; a blank or malformed entry means "no cutoff" for that window */
  var CUTS = String(attr('data-cuts', '')).split(',').map(function (s) {
    var m = /^\s*(\d{1,2})(?::(\d{2}))?\s*$/.exec(s);
    return m ? (+m[1]) + (m[2] ? (+m[2]) / 60 : 0) : NaN;
  });
  var WIN = (function () {
    var v = String(attr('data-windows', '')).split(',').map(function (s) { return s.trim(); });
    return (v.length === 3 && v[0] && v[1] && v[2]) ? v : WIN_EN;
  })();

  var T = {
    orderby: attr('data-t-orderby', 'Order by {time}'),
    closed: attr('data-t-closed', 'Closed for today'),
    err: attr('data-t-closederr', 'That time has closed for today. Choose another.'),
    next: attr('data-t-next', 'Order by {time} for {window} delivery.')
  };

  function kNow() { var n = new Date(); return new Date(n.getTime() + (n.getTimezoneOffset() + 180) * 6e4); }
  function nowDec() { var n = kNow(); return n.getHours() + n.getMinutes() / 60; }
  /* 24 (midnight) prints as 12:00 AM / 12:00 بالليل. Arabic day-part words match the window labels */
  function fmtIn(h, ar) {
    var H = Math.floor(h), M = Math.round((h - H) * 60);
    if (M === 60) { H += 1; M = 0; }
    var mm = (M < 10 ? '0' : '') + M, H24 = H % 24, h12 = (H24 % 12) || 12;
    if (ar) { return h12 + ':' + mm + ' ' + (H24 >= 21 || H24 < 5 ? 'بالليل' : H24 < 12 ? 'الصبح' : H24 < 15 ? 'الظهر' : H24 < 18 ? 'العصر' : 'المغرب'); }
    return h12 + ':' + mm + ' ' + (H24 < 12 ? 'AM' : 'PM');
  }
  function fmt(h) { return fmtIn(h, AR); }
  /* a window is closed for today once its own cutoff has passed, or once same-day ordering has ended */
  function closed(i) { var n = nowDec(); return n >= DAY_CUT || (isFinite(CUTS[i]) && n >= CUTS[i]); }
  /* was this sheet built with Today as its first day? (the day number on the first button is today's) */
  function builtToday() {
    var d0 = document.querySelector('.fluid-oday[data-d="0"] .dn');
    return !!d0 && String(d0.textContent).trim() === String(kNow().getDate());
  }
  function todaySelected() {
    var d = document.querySelector('.fluid-oday.on');
    return !!d && d.getAttribute('data-d') === '0' && builtToday();
  }
  function setCls(el, cls, on) { if (el.classList.contains(cls) !== on) { el.classList.toggle(cls, on); } }

  var lastOn = null, busy = false, errOrig = null;

  function apply() {
    if (busy) { return; }
    busy = true;
    try {
      var times = document.querySelectorAll('.fluid-otime');
      if (!times.length) { lastOn = null; return; }
      var today = todaySelected(), i, b, hint, isClosed, txt;
      for (i = 0; i < times.length; i++) {
        b = times[i];
        hint = b.querySelector('.otf-cut');
        if (!hint) { hint = document.createElement('small'); hint.className = 'otf-cut'; b.appendChild(hint); }
        isClosed = today && closed(i);
        txt = today ? (isClosed ? T.closed : (isFinite(CUTS[i]) ? T.orderby.replace('{time}', fmt(CUTS[i])) : '')) : '';
        if (hint.textContent !== txt) { hint.textContent = txt; }
        if (b.classList.contains('on')) { lastOn = i; }
        if (isClosed) {
          if (!b.disabled) { b.disabled = true; }
          setCls(b, 'on', false);
        }
        setCls(b, 'otf-closed', isClosed);
      }
      /* nothing left for today at all: Today cannot be ordered any more */
      var allClosed = builtToday() && CUTS.every(function (c, k) { return closed(k); });
      var d0 = document.querySelector('.fluid-oday[data-d="0"]');
      if (d0 && d0.disabled !== allClosed) { d0.disabled = allClosed; }
    } finally { busy = false; }
  }

  var raf = 0;
  function schedule() { if (!raf) { raf = requestAnimationFrame(function () { raf = 0; apply(); paintNext(); }); } }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i], t = m.target;
      if (m.type === 'attributes') {
        if (t.classList && (t.classList.contains('fluid-otime') || t.classList.contains('fluid-oday'))) { schedule(); return; }
      } else if (m.addedNodes.length) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && (n.classList.contains('fluid-otime') || (n.querySelector && n.querySelector('.fluid-otime')))) { schedule(); return; }
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });

  setInterval(function () { if (document.querySelector('.fluid-otime')) { apply(); } paintNext(); }, 30000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { schedule(); } });

  /* the time error line: our text while a closed window is the problem, fluid-motion's text otherwise */
  function timeErr() { return document.querySelector('.fluid-oerr[data-e="time"]'); }
  function showClosedErr() {
    var e = timeErr(); if (!e) { return; }
    if (errOrig === null) { errOrig = e.textContent; }
    e.textContent = T.err;
    setCls(e, 'on', true);
    e.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function clearClosedErr() {
    var e = timeErr(); if (!e || errOrig === null) { return; }
    e.textContent = errOrig; errOrig = null;
    setCls(e, 'on', false);
  }

  /* the 9pm straddle: rebuild the sheet so its day list is fresh, carrying the typed fields across */
  function rebuildSheet() {
    var back = document.querySelector('.fluid-oback');
    var opener = document.querySelector('[data-openorder], .fluid-checkout');
    if (!back || !opener) { return false; }
    var keep = {}, f = ['msg', 'name', 'phone', 'note'], k;
    for (k = 0; k < f.length; k++) { var el = document.querySelector('[data-f="' + f[k] + '"]'); if (el) { keep[f[k]] = el.value; } }
    errOrig = null;
    back.click();
    setTimeout(function () {
      opener.click();
      setTimeout(function () {
        for (var j = 0; j < f.length; j++) {
          var el2 = document.querySelector('[data-f="' + f[j] + '"]');
          if (el2 && keep[f[j]]) { el2.value = keep[f[j]]; el2.dispatchEvent(new Event('input', { bubbles: true })); }
        }
      }, 700);
    }, 450);
    return true;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) { return; }
    var day = e.target.closest('.fluid-oday');
    if (day) {
      clearClosedErr();
      if (builtToday() && nowDec() >= DAY_CUT && rebuildSheet()) { e.preventDefault(); e.stopImmediatePropagation(); }
      return;
    }
    if (e.target.closest('.fluid-otime')) { clearClosedErr(); return; }
    var go = e.target.closest('button.fluid-ogo');
    if (!go || go.hasAttribute('data-openorder') || go.hasAttribute('data-giftadd')) { return; }
    if (!document.querySelector('.fluid-otime')) { return; }   /* not the order sheet */
    apply();
    var bad = todaySelected() && (lastOn === null ? CUTS.every(function (c, k) { return closed(k); }) : closed(lastOn));
    if (bad) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showClosedErr();
    }
  }, true);

  /* at Continue: fluid-motion's stale "6:00 PM - 11:45 PM" becomes "6:00 PM - 9:00 PM" on the order */
  if (typeof window.fetch === 'function' && !window.__otfSlotFetch) {
    window.__otfSlotFetch = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        if (init && typeof init.body === 'string' && /\/cart\/update\.js(\?|$)/.test(url)) {
          var body = JSON.parse(init.body), a = body && body.attributes, v = a && a['Delivery Time'];
          if (v === OLD_THIRD) { a['Delivery Time'] = WIN_EN[2]; init = Object.assign({}, init, { body: JSON.stringify(body) }); }
        }
      } catch (err) { /* never let this break a fetch */ }
      return nativeFetch.call(this, input, init);
    };
  }

  /* ---- the home page: one more sentence on the 9pm line ---- */
  function paintNext() {
    var box = document.querySelector('[data-cut]');
    if (!box) { return; }
    var el = box.querySelector('[data-otf-next]');
    if (!el) { el = document.createElement('p'); el.className = 'cutnote otf-next'; el.setAttribute('data-otf-next', ''); box.appendChild(el); }
    var txt = '', i;
    if (nowDec() < DAY_CUT) {
      for (i = 0; i < CUTS.length; i++) {
        if (isFinite(CUTS[i]) && !closed(i)) { txt = T.next.replace('{time}', fmt(CUTS[i])).replace('{window}', WIN[i] || WIN_EN[i]); break; }
      }
    }
    if (el.textContent !== txt) { el.textContent = txt; }
    if (el.hidden !== !txt) { el.hidden = !txt; }
  }

  var st = document.createElement('style');
  /* the hint sits inline, right of the label and left of the tick, so the 52px
     button keeps its height; margin-inline mirrors on /ar by itself. */
  st.textContent =
    '.fluid-otime .otf-cut{font-size:12px;font-weight:500;line-height:1;opacity:.62;margin-inline-start:auto;margin-inline-end:10px;white-space:nowrap}' +
    '.fluid-otime .otf-cut:empty{display:none}' +
    'button.fluid-otime[disabled].otf-closed{opacity:.55}' +
    '.fluid-otime.otf-closed .otf-cut{opacity:1;font-weight:600}' +
    '.fluid-cut .otf-next{font-weight:600;color:var(--fl-text2)}' +
    '.fluid-cut .otf-next[hidden]{display:none}';
  document.head.appendChild(st);

  schedule();
})();